export var TooltipConfig = {
    timeToWaitBeforeClosingTooltip: 200,
};
//# sourceMappingURL=TooltipConfig.js.map